import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getDeposit(userID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/deposit/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpGet(apiUrl);
  }

  addDepositLog(userID, type, depositData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/deposit/${Crypto.encrypt(userID, CryptoKey)}?type=${type}`;
    return httpPost(apiUrl, depositData);
  }

  getDepositLogsByDate(dateBegin, dateEnd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/deposit/logs/list?dateBegin=${dateBegin}&dateEnd=${dateEnd}`;
    return httpGet(apiUrl);
  }

  getDepositLogsByConditions(conditions) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/deposit/logs/conditions`;
    return httpPost(apiUrl, conditions);
  }

  deleteDeposit(userID, data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/deposit/log/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpDelete(apiUrl, data);
  }

  editDepositLog(userID, depositData) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/deposit/log/${Crypto.encrypt(userID, CryptoKey)}`;
    return httpPost(apiUrl, depositData);
  }

  getDepositLogByUserIDAndDateTime(userID, dateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/deposit/log/${Crypto.encrypt(userID, CryptoKey)}?dateTime=${dateTime}`;
    return httpGet(apiUrl);
  }
}
